/**
 * BillingAccountAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateClientDto } from '../model/createClientDto';
import { ModifyClientDto } from '../model/modifyClientDto';
import { ProblemDetails } from '../model/problemDetails';
import { ReadClientDto } from '../model/readClientDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ClientService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientCreateClientPost(body?: CreateClientDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiClientCreateClientPost(body?: CreateClientDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiClientCreateClientPost(body?: CreateClientDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiClientCreateClientPost(body?: CreateClientDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/Client/CreateClient`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientDeleteClientDelete(clientId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiClientDeleteClientDelete(clientId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiClientDeleteClientDelete(clientId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiClientDeleteClientDelete(clientId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('ClientId', <any>clientId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/Client/DeleteClient`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetAllClientGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ReadClientDto>>;
    public apiClientGetAllClientGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadClientDto>>>;
    public apiClientGetAllClientGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadClientDto>>>;
    public apiClientGetAllClientGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadClientDto>>('get',`${this.basePath}/api/Client/GetAllClient`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param authId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetClientByAuthIdGet(authId?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadClientDto>;
    public apiClientGetClientByAuthIdGet(authId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadClientDto>>;
    public apiClientGetClientByAuthIdGet(authId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadClientDto>>;
    public apiClientGetClientByAuthIdGet(authId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authId !== undefined && authId !== null) {
            queryParameters = queryParameters.set('AuthId', <any>authId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadClientDto>('get',`${this.basePath}/api/Client/GetClientByAuthId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetClientByClientIdGet(clientId?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadClientDto>;
    public apiClientGetClientByClientIdGet(clientId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadClientDto>>;
    public apiClientGetClientByClientIdGet(clientId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadClientDto>>;
    public apiClientGetClientByClientIdGet(clientId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('ClientId', <any>clientId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadClientDto>('get',`${this.basePath}/api/Client/GetClientByClientId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param billingEmail 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientGetClientsByBillingEmailGet(billingEmail?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReadClientDto>>;
    public apiClientGetClientsByBillingEmailGet(billingEmail?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadClientDto>>>;
    public apiClientGetClientsByBillingEmailGet(billingEmail?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadClientDto>>>;
    public apiClientGetClientsByBillingEmailGet(billingEmail?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (billingEmail !== undefined && billingEmail !== null) {
            queryParameters = queryParameters.set('BillingEmail', <any>billingEmail);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadClientDto>>('get',`${this.basePath}/api/Client/GetClientsByBillingEmail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientUpdateClientPut(body?: ModifyClientDto, observe?: 'body', reportProgress?: boolean): Observable<ReadClientDto>;
    public apiClientUpdateClientPut(body?: ModifyClientDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadClientDto>>;
    public apiClientUpdateClientPut(body?: ModifyClientDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadClientDto>>;
    public apiClientUpdateClientPut(body?: ModifyClientDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ReadClientDto>('put',`${this.basePath}/api/Client/UpdateClient`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
